<ng-template #footer>
    <ng-template #twoColumnsRight>
        <shared-btn class="modal-for-alert__action-btn" (onClick)="handleCloseClick($event)">
            {{ modalData?.params?.buttonLabel ? modalData.params.buttonLabel : 'ok' }}
        </shared-btn>
    </ng-template>
    <shared-two-columns class="modal-for-alert__actions" [left]="null" [right]="twoColumnsRight"></shared-two-columns>
</ng-template>

<shared-modal-type-dynamic-height
    [footer]="footer"
    [footerBorder]="false"
    [modalData]="modalData"
    [center]="true"
    [mobilePreserve]="true"
    [minHeight]="minHeight"
    [size]="size"
    (onScrollInit)="handleScrollInit($event)"
    (onCloseClick)="handleCloseClick($event)"
    class="modal-for-alert"
>
    <shared-header *ngIf="modalData.params?.preTitle" [center]="true" [brandAccent]="true" type="5" marginTop="md" marginBottom="none" class="modal-for-alert__sub-h"
        >{{ modalData.params.preTitle }}
    </shared-header>

    <shared-header *ngIf="modalData.params?.title" [center]="true" class="modal-for-alert__h" type="2" [marginTop]="modalData.params?.preTitle ? 'xs' : 'md'" marginBottom="md">
        {{ modalData.params.title }}
    </shared-header>

    <div class="modal-for-alert__content" *ngIf="modalData.params?.body">
        {{ modalData.params.body }}
    </div>
</shared-modal-type-dynamic-height>
